import { makeStyles, Theme } from '@material-ui/core/styles';

export const useOpenAppBannerStyles = makeStyles((theme: Theme) => ({
	root: {
		position: 'fixed',
		left: 0,
		right: 0,
		bottom: 56,
		zIndex: theme.zIndex.appBar,
		maxWidth: 600,
		margin: '0 auto',
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		gap: `${theme.spacing(1)}px`,
		padding: theme.spacing(1),
		borderBlockStart: `1px solid ${theme.palette.common.white}`,
		backgroundColor: 'rgb(232, 84, 21)',
		[theme.breakpoints.up('sm')]: {
			bottom: 0,
		},
	},
	closeButton: {
		color: theme.palette.common.white,
	},
	link: {
		flex: 1,
		alignSelf: 'stretch',
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		cursor: 'pointer',
		textDecoration: 'none',
		textAlign: 'left',
	},
	messageText: {
		color: theme.palette.common.white,
		fontWeight: 'bold',
	},
	openIcon: {
		color: theme.palette.common.white,
		margin: theme.spacing(1),
	},
}));
